import React from 'react';
import QuickLink from '../../../basic/quickLink';
import { ISubLinksFooterProps } from '../IFooter';
import { SiteMapDialogAction } from '../../../../types';
import OneTrustLink from '../../../basic/oneTrustLink';
import { DataAnalyticsLocations, DataAnalyticsTypes, buildAnalytics } from '../../../basic/analytics';
import { useTranslator } from '../../header/locales-provider';

const SubLinks = ({ items ,index,listCount}: ISubLinksFooterProps): JSX.Element => {
  const { label, url, action } = items || {};
  const locales = useTranslator('global');

  if (action && action === SiteMapDialogAction.ONE_TRUST)
    return (
      <OneTrustLink className='py-xs' label={label} />
    )

  return (
    <div className="py-xs" role="listitem">
      <QuickLink className="text-white text-base hover:text-secondary-200 hover:underline-offset-4 hover:underline" href={url} isExternal={items?.isExternal || false}
        dataAnalytics={buildAnalytics(DataAnalyticsLocations.Footer, DataAnalyticsTypes.Link)}
        aria-label={`${label}, ${index + 1} of ${listCount} ${items.isExternal ? locales?.['aria.label.newTab'] : ''}`}>
        {label}
      </QuickLink>
    </div>
  );
};

export default SubLinks;
